import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 1,
  class: "flex align_center h100"
};
const _hoisted_4 = {
  class: "link pointer"
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = ["size"];
const _hoisted_7 = {
  class: "scroll_y flex align_center justify_center"
};
const _hoisted_8 = {
  key: 0,
  style: {
    "width": "100%",
    "max-width": "60vw"
  }
};
const _hoisted_9 = {
  class: "bold mb_1 text_gray_1"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
import { watch, ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'YImageView',
  props: {
    size: {},
    show: {
      type: Boolean
    },
    square: {
      type: Boolean
    },
    simple: {
      type: Boolean,
      default: true
    },
    img: {},
    text: {
      default: "查看"
    },
    proofs: {},
    imgSize: {
      default: 60
    }
  },
  setup(__props) {
    const props = __props;
    const curImg = ref([]);
    const proofs = ref([]);
    const show = ref(props.show);
    // const emit = defineEmits(["update:show"])
    watch(() => props.img, newValue => {
      let tempArr = [];
      if (newValue && Array.isArray(newValue)) {
        curImg.value = newValue;
      } else if (newValue) {
        if (newValue.indexOf(",") != -1) {
          tempArr = newValue.split(",");
        } else {
          tempArr[0] = newValue;
        }
        curImg.value = tempArr;
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => props.proofs, newValue => {
      if (newValue && newValue.length) {
        newValue.forEach(item => {
          if (!Array.isArray(item.proofUrl)) {
            item.proofUrl = item.proofUrl.split(",");
          }
        });
        proofs.value = newValue;
        console.log("proofs.value", proofs.value);
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_Btn = _resolveComponent("Btn");
      const _component_viewer = _resolveComponent("viewer");
      const _component_Popup = _resolveComponent("Popup");
      return _openBlock(), _createElementBlock(_Fragment, null, [curImg.value && curImg.value.length || proofs.value && proofs.value.length ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => show.value = !show.value, ["stop"])),
        class: _normalizeClass(["row col-center shrink_0 h100", _ctx.square ? _ctx.css.small_img : 'k-cursor-pointer'])
      }, [_ctx.square || !_ctx.simple ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curImg.value, (item, index) => {
        return _openBlock(), _createElementBlock("img", {
          class: _normalizeClass(_ctx.css.small_img),
          src: item,
          alt: "",
          style: _normalizeStyle({
            objectFit: 'cover',
            width: `${_ctx.imgSize}px`,
            height: `${_ctx.imgSize}px`,
            borderRadius: '8px'
          })
        }, null, 14, _hoisted_2);
      }), 256))])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "default", {}, () => [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.text), 1)])]))], 2)) : (_openBlock(), _createElementBlock("div", _hoisted_5, "暂无")), _createVNode(_component_Popup, {
        title: "查看图片",
        bodyStyle: {
          'max-height': '100%'
        },
        show: show.value
      }, {
        footer: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(_ctx.css.close)
        }, [_createVNode(_component_Btn, {
          onClick: _cache[1] || (_cache[1] = $event => show.value = false),
          class: _normalizeClass(_ctx.css.btn_close)
        }, {
          default: _withCtx(() => [_createTextVNode("关闭")]),
          _: 1
        }, 8, ["class"])], 2)]),
        default: _withCtx(() => [_createElementVNode("div", {
          size: _ctx.size
        }, [_createElementVNode("div", _hoisted_7, [proofs.value && proofs.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(proofs.value, (item, index) => {
          return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.proofTypeDesc), 1), _createElementVNode("div", null, [_createVNode(_component_viewer, {
            trigger: item.proofUrl,
            style: {
              "display": "flex",
              "flex-wrap": "wrap"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.proofUrl, (item1, index) => {
              return _openBlock(), _createElementBlock("img", {
                src: item1,
                style: {
                  "height": "100px",
                  "margin-right": "10px",
                  "margin-bottom": "10px"
                },
                key: index,
                class: "pointer y_image_view_img",
                title: "点击查看大图，旋转，缩放"
              }, null, 8, _hoisted_10);
            }), 128))]),
            _: 2
          }, 1032, ["trigger"])])], 64);
        }), 256))])) : (_openBlock(), _createBlock(_component_viewer, {
          key: 1,
          trigger: curImg.value,
          style: {
            "width": "375px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curImg.value, (src, index) => {
            return _openBlock(), _createElementBlock("img", {
              src: src,
              style: {
                "max-height": "70vh"
              },
              key: index,
              class: "pointer y_image_view_img",
              title: "点击查看大图，旋转，缩放"
            }, null, 8, _hoisted_11);
          }), 128))]),
          _: 1
        }, 8, ["trigger"]))])], 8, _hoisted_6)]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
});